<template>
	<div class="container">
		<h3>Clean Homes Fees</h3>
		<div class="d-flex justify-content-center">
			<div class="">
				<template v-if="fees.data.length">
					<div
						v-for="fee in fees.data"
						:key="fee.id"
						class="card mb-2">
						<div class="card-body">
							<div class="d-flex flex-lg-nowrap flex-wrap">
								<div class="flex-grow-1 mr-4">
									<p>
										<strong>{{ fee.title }}</strong><br>
										<template v-if="fee.service">
											{{ formatTimestamp(fee.service.date) }}<br>
											{{ fee.service.hours }} hour/s - ${{ fee.amount }}<br>
											<small class="text-danger">If the hours are not correct, please contact your
												team manager.</small><br>
										</template>
										<template v-else>
											${{ fee.amount }}
										</template>
									</p>
								</div>
								<div class="text-right flex-grow-1">
									<p>Was this job completed?</p>
									<button
										type="button"
										class="btn  ml-2"
										:class="[ fee.action == 'Completed' ? 'btn-primary' : 'btn-light']"
										@click="fee.action = 'Completed'">
										Yes
									</button>
									<button
										type="button"
										class="btn "
										:class="[ fee.action == 'Cancelled' ? 'btn-primary' : 'btn-light']"
										@click="fee.action = 'Cancelled'">
										No
									</button>
								</div>
							</div>

							<div
								v-if="fee.action == 'Cancelled'"
								class="form-group mt-2">
								<label>Please select the reason that this job was completed.</label>
								<select
									class="form-control"
									:name="fee.id + '_reason'"
									:value="fee.reason"
									@change="fee.reason = $event.target.value">
									<option></option>
									<option>- Client cancelled permanently</option>
									<option>- Client Away</option>
									<option>- Client forgot to leave key</option>
									<option>- Cleaner Away</option>
									<option>- Job not yet started</option>
									<option>- Service not required this week</option>
									<option>- Public Holiday</option>
									<option>- Job on hold Corona Virus</option>
								</select>
								<div class="invalid-feedback">
									{{ getValidationErrors(fee.id + '_reason') }}
								</div>
								<div class="">
									<p></p>
								</div>
							</div>
						</div>
					</div>
					<div v-if="!fees.data.length">
						<p class="text-center">
							There are no fees available to mark at this time.
						</p>
					</div>
					<button
						v-if="fees.data.length"
						class="btn btn-block btn-lg btn-primary mb-2"
						@click="showConfirmationModal">
						Submit
					</button>
				</template>
			</div>
		</div>

		<clean-homes-fees-modal ref="cleanHomesFeesModal" @submit="markFees"></clean-homes-fees-modal>
	</div>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import CleanHomesFeesModal from './CleanHomesFeesModal.vue';

	export default {
		components: {CleanHomesFeesModal},
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				fees: {
					data: [],
					meta: {}
				},
				cleaner: {},
				submitting: false
			}
		},
		computed: {
			user() {
				return this.$store.getters['auth/user'];
			}
		},
		mounted() {
			this.fetchFees();
		},
		methods: {
			fetchFees() {
				this.loading = true;

				this.$axios.get('/api/cleaner/fees', {
					params: {
						page: this.fees.meta.current_page,
						company: 'Clean Homes'
					},

				}).then((response) => {
					this.fees.meta = response.data.meta;
					this.fees.data = response.data.data.map(item => {
						item.action = '';
						item.reason = '';
						return item
					});

					this.loading = false;
				}).catch(error => {
					if ([403, 500].includes(error.response.status)) {
						toastr.error(error.response.data.message);
					}
				});
			},
			showConfirmationModal() {
				let selected_fees = this.fees.data.filter(item => item.action != '');

				if (!selected_fees.length) {
					toastr.error('You must select some fees.');
					return;
				}

				this.$refs.cleanHomesFeesModal.open();
			},
			markFees() {
				this.submitting = true;
				const data = this.fees.data
					.filter(item => item.action != '')
					.map(item => ({
						id: item.id,
						status: item.action,
						reason: item.reason
					}))

				this.$axios.post('/api/cleaner/clean-homes-fees/mark', data)
					.then(() => {
						this.fetchFees();
						toastr.success('Updated.');
						this.$refs.cleanHomesFeesModal.close();
					})
					.catch(error => {
						this.handleError(error);
						if (error.response.status === 422) {
							toastr.error('Submission Invalid. Please check the form for errors and try again.');
						}
					})
					.finally(() => (this.submitting = false))
			},
			formatTimestamp(value) {
				return moment(value).format('DD/MM/YYYY');
			},

		}
	}
</script>

<style lang="scss" scoped>
.invalid-feedback {
	display: block;
}
</style>
